module.exports = __webpack_public_path__ + "img/access.e876dc2c.svg";